import React from 'react';
import styled from 'styled-components';
import { ReactComponent as DoctornowIcon } from '@/assets/images/common/doctornowIcon.svg';
import { Pharmacy } from '@/apis/pharmacy/interface';
import { Notification } from '@/recoil/notification';
import { useHistory } from 'react-router-dom';
import { VERSION } from '@/constants/version';
import LineButton, { ButtonColorType } from '@/components/ButtonComponent/LineButton';
import NavigationMenu from '@/components/AppLayout/containers/NavigationMenu';
import LnbBanner from '@/components/Advertisement/LnbBanner';
import theme from '@/styles/theme';

interface Props {
  isLoggedIn: boolean;
  displayTodayDuty: string;
  goMain: () => void;
  pharmacy: Pharmacy;
  notification: Notification;
  setNotification: React.Dispatch<Notification>;
}

const Navigation = (props: Props) => {
  const { pharmacy, displayTodayDuty, goMain, isLoggedIn } = props;
  const history = useHistory();

  const onClickTerm = () => {
    history.push('/term');
  };

  return (
    <Wrapper>
      <NavTop>
        <Pharm onClick={goMain}>
          <DoctornowIcon width={28} height={28} />
          <div className={'pharmacy-name'}>{pharmacy?.pharmacy?.name}</div>
          {displayTodayDuty && (
            <div className={'duty-time'}>
              {displayTodayDuty}
            </div>
          )}
        </Pharm>
        <NavigationMenu />
      </NavTop>
      <NavBottom>
        {isLoggedIn && <LnbBanner />}
        <div className={'button-wrapper'}>
          <LineButton
            type={ButtonColorType.PRIMARY}
            style={{
              width: 160,
              height: 48,
              borderRadius: 5,
              marginBottom: 10
            }}
            onClick={() => {
              window.open(
                'https://sites.google.com/doctornow.co.kr/guide-pharmacy',
                'guide'
              );
            }}>
            필독 가이드
          </LineButton>
          <LineButton
            type={ButtonColorType.DEFAULT}
            style={{ width: 160, height: 48, borderRadius: 5 }}
            onClick={onClickTerm}>
            약관 보기
          </LineButton>
        </div>
        <div className={'version'}>Ver {VERSION}</div>
      </NavBottom>
    </Wrapper>
  );
};

export default Navigation;

const Wrapper = styled.div`
  display: flex;
  position: fixed;
  flex-direction: column;
  justify-content: space-between;
  top: 80px;
  width: 260px;
  background: ${theme.DF_COLOR.WHITE};
  z-index: 997;
  overflow-y: scroll;
  box-sizing: border-box;
  position: relative;

  .pharmacy-name {
    ${({ theme }) => theme.DF_TYPOGRAPHY.UI20B};
    color: ${({ theme }) => theme.DF_COLOR.GRAY900};
  }

  .duty-time {
    margin-top: 8px;
    ${({ theme }) => theme.DF_TYPOGRAPHY.UI15R};
    color: ${({ theme }) => theme.DF_COLOR.BLUE700};
  }
`;

const NavTop = styled.div`
  margin-bottom: 20px;
`;

const NavBottom = styled.div`
  text-align: center;
  width: 100%;
  height: 448px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  position: relative;
  bottom: 0;

  .button-wrapper {
    height: 112px;
    margin-bottom: 30px;
    position: absolute;
    bottom: 120px;
  }

  .version {
    ${({theme}) => theme.DF_TYPOGRAPHY.UI16R};
    color: ${({theme}) => theme.DF_COLOR.GRAY400};
    position: absolute;
    bottom: 32px;
  }
`;

const Pharm = styled.div`
  padding: 40px 0 30px 40px;

  cursor: pointer;

  > * {
    &:nth-child(1) {
      margin-bottom: 10px;
    }

    &:nth-child(2) {
      margin-bottom: 5px;
    }
  }
`;
